// extracted by mini-css-extract-plugin
export default {"simple_bar":"seatedEmployeesByDepartment_simple_bar__1f6sw","after":"seatedEmployeesByDepartment_after__IsvFF","before":"seatedEmployeesByDepartment_before__UiILq"};